/**
 * Sovelluksen oma merkki — eri asia kuin yrityksen tunnus (`Logo`).
 *
 * Tunnus kertoo kenen järjestelmä tämä on ja sen voi vaihtaa hallinnasta;
 * merkki kertoo mikä järjestelmä tämä on, eikä se vaihdu asennuksen
 * mukana. Siksi se on koodissa eikä kannassa.
 *
 * Kuvio on mittarikaari: kello, jonka kehälle kertyy kirjattu aika. Kaari
 * alkaa kello kahdestatoista ja kulkee 240 astetta — kahdentoista tunnin
 * taulusta kahdeksan tuntia, eli täysi työpäivä. Kärjessä on Devikoneen
 * punainen piste, sama väri kuin yrityksen sanamerkissä.
 *
 * Muste on `currentColor`, joten merkki värittyy sen mukaan, mikä teema
 * sovelluksessa on **valittu**. Sama geometria on tiedostossa
 * `public/favicon.svg`, joka seuraa käyttöjärjestelmän teemaa — se
 * piirretään ennen kuin sovellus on ladattu. Molemmat syntyvät samasta
 * lähteestä: `scripts/ikonit.mjs` (`pnpm ikonit`). Jos muutat lukuja,
 * muuta ne sinne ja aja skripti — tämä tiedosto on ainoa käsin ylläpidetty
 * kopio, ja sen pitää pysyä samana.
 */

/** Devikoneen punainen. Kiinteä molemmissa teemoissa: se erottuu kummallakin taustalla. */
const PUNAINEN = '#df221d';

export default function SovellusMerkki({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      // Merkki on nimen vieressä eikä sen sijasta, joten se on koriste:
      // ruudunlukija lukisi muuten sovelluksen nimen kahteen kertaan.
      aria-hidden="true"
      focusable="false"
    >
      {/* Rata: koko kello. Kertymä on ymmärrettävä vain, jos näkyy myös
        se, mihin asti kaari voisi yltää. */}
      <circle
        cx="16"
        cy="16"
        r="11.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.2"
        opacity="0.18"
      />
      {/* Kertynyt aika. Katkaistu pää klo 12:ssa on tarkoituksella terävä:
        pyöristettynä se näyttäisi liukuvan alkupisteen ohi. */}
      <path
        d="M 16.00 4.60 A 11.4 11.4 0 1 1 6.13 21.70"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.2"
      />
      <path
        d="M 16 16 L 11.15 18.80"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <circle cx="6.13" cy="21.70" r="3.1" fill={PUNAINEN} />
    </svg>
  );
}
